import Injection = EECore.Injection;
import CurrentPromotion from "../entities/promotion/currentPromotion";
import PersonnalInformation from "../entities/promotion/personnalInformation";
import ElectronicServicesSubscriptionResult from "../entities/promotion/electronicServicesSubscriptionResult";

@Injection.injectableClass("PromotionService")
export default class PromotionService {

  @Injection.injectableProperty("PromotionService", EECore.Registrations.HTTP_CLIENT)
  private httpClient: EECore.HttpClient;

  constructor(httpClient: EECore.HttpClient) {
    this.httpClient = httpClient;
  }

  getCurrentPromotion() {
    const url = "/wemwpn49/api/promotion/active";
    return this.httpClient.get<CurrentPromotion>(url, true);
  }

  getProfileReviewContent() {
    return this.httpClient.getHtml("/cw/promotions/personal-information-review-banner", true);
  }

  getPersonalizedAccessCodeContent() {
    return this.httpClient.getHtml("/cw/promotions/username-banner", true);
  }

  getElectronicFeaturesContent() {
    return this.httpClient.getHtml("/cw/promotions/electronic-services-banner", true);
  }

  getSecuredMessagingContent() {
    return this.httpClient.getHtml("/cw/promotions/secure-messaging-banner", true);
  }

  getPersonnalInformation() {
    const url = "/wemwpn42/api/contactinformation";
    return this.httpClient.get<PersonnalInformation>(url, true);
  }

  updateReminder(promotionCode: string) {
    const url = `/wemwpn49/api/reminder/${promotionCode}`;
    return this.httpClient.put(url, true);
  }

  subscribeToElectronicServices(): EECore.Promise<ElectronicServicesSubscriptionResult, string> {
    return new EECore.Promise<ElectronicServicesSubscriptionResult, string>((resolve, reject) => {
      const url = "/wemwpn42/api/electronicservices/subscription";
      const request = this.httpClient.sendRequest(url, "PUT", null, true);
      request.then((response) => {
        resolve(JSON.parse(response));
      }).catch((error) => {
        reject(error);
      });
    });
  }
}